"use client";

import Image from "next/image";
import OrganisationCategories from "./org-categories";
import Skeleton from "react-loading-skeleton";
import Pagination from "../common/Pagination";
import styles from "./index.module.css";
import { useState } from "react";
import { useModalManager } from "../modal/useModalManager";
import FloatingHelper from "../store/template/default/floating-helper";

const OrgList = ({
  handleSwitch,
  state,
  openPage,
  token,
  isLoading,
  isFetching,
  currentAcc = null,
}) => {
  const [imageLoadedMap, setImageLoadedMap] = useState({});
  const handleImageLoad = (accessPointId) => {
    setImageLoadedMap((prev) => ({ ...prev, [accessPointId]: true }));
  };

  const formatOrgName = (name = "") =>
    name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");

  const shouldShowAccessPointName = (name = "") =>
    name.trim().toLowerCase() !== "main entrance";

  const currentAccessPointId = currentAcc
    ? (currentAcc.accessPointId ?? currentAcc)
    : null;

  const visibleAccessPoints = (state.accessPoints || []).filter(
    (acc) => acc.accessPointId !== currentAccessPointId,
  );

  const { modal } = useModalManager();
  const [isShowingFloater, setIsShowingFloater] = useState(false);

  return (
    <>
      <div className={styles.marketPlaceOrganisations}>
        {visibleAccessPoints.map((acc) => {
          const isLoaded = imageLoadedMap[acc.accessPointId];
          const address = acc.address || acc.ordDetails?.address;
          const description = acc.orgDetails?.description;
          return (
            <div
              key={acc.accessPointId}
              className={styles.organisation}
              onClick={() => handleSwitch(acc)}
            >
              <div className={styles.organisationInfo}>
                {!acc.orgDetails?.logoUrl && (
                  <div className={styles.organisationPlaceholderLogo}>
                    {acc.orgDetails?.orgName?.[0]?.toUpperCase() || "?"}
                  </div>
                )}
                {acc.orgDetails?.logoUrl && (
                  <div className={styles.organisationLogoFrame}>
                    {!isLoaded && <Skeleton width={70} height={70} circle />}
                    <Image
                      src={acc.orgDetails?.logoUrl}
                      alt={`${acc.orgDetails?.orgName} logo`}
                      width={70}
                      height={70}
                      className={styles.organisationLogo}
                      onLoad={() => handleImageLoad(acc.accessPointId)}
                      style={{
                        opacity: isLoaded ? 1 : 0,
                      }}
                    />
                  </div>
                )}
                <div className={styles.textInfo}>
                  {/* <p className={styles.organisationName}>
                    {acc.orgDetails?.orgName
                      .split(" ")
                      .map(
                        (word) =>
                          word.charAt(0).toUpperCase() +
                          word.slice(1).toLowerCase(),
                      )
                      .join(" ")}
                  </p> */}
                  <p className={styles.organisationName}>
                    {[
                      formatOrgName(acc.orgDetails?.orgName),
                      shouldShowAccessPointName(acc.name) ? acc.name : null,
                    ]
                      .filter(Boolean)
                      .join(" - ")}
                  </p>
                  <div className={styles.infoDiv}>
                    <p className={styles.organisationMeta}>
                      {[
                        description,
                        address ? `Address: ${address}` : null,
                      ]
                        .filter(Boolean)
                        .join(" • ")}
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles.organisationCategories}>
                <OrganisationCategories
                  acc={acc}
                  token={token}
                  handleSwitch={handleSwitch}
                />
              </div>
            </div>
          );
        })}
      </div>
      <Pagination
        infiniteScroll={true}
        total={state.total}
        limit={state.limit}
        page={state.page}
        onPageClick={openPage}
        enableManualMode={true}
        autoLoadThreshold={5}
        isLoading={isLoading}
        isFetching={isFetching}
        showEndOfList={true}
        endOfListText="🎉 You've reached the end!"
      />

      <FloatingHelper modal={modal} setIsShowingFloater={setIsShowingFloater} />
    </>
  );
};
export default OrgList;
